<ls-linescale [scaleText]="scaleText()"
  [ratings]="[]" [tickMark]="tickMark()"
  [items]="items()"></ls-linescale>